import { Layout, Menu, MenuProps } from "antd";
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import MainVideo from "../../assets/images/myindici-logo.png";
import "../../assets/css/section.css";
import {Button } from "react-bootstrap";
import { Drawer } from 'antd';

interface Homeprops {
  activeMenuItem?: any,
  handleMenuItemClick?: any
}

const { Header } = Layout;
type MenuItem = Required<MenuProps>['items'][number];

export const NavbarHeader: React.FunctionComponent<Homeprops> = (props) => {
  function getItem(
    label: React.ReactNode,
    key: React.Key, // Include key as a parameter
    icon?: React.ReactNode,
    path?: string // Add path as a parameter
  ): MenuItem {
    
    return {
      key,
      icon,
      label,
      className:props.activeMenuItem === key ? 'ant-menu-item-selected' : undefined,
      onClick: () => props.handleMenuItemClick(key),
    } as MenuItem;
  }
  
  const itemsMenuAdmin: MenuItem[] = [
    getItem(<Link to="/">Home</Link>, 'Home'),
    getItem(<Link to="/our-story">Our Story</Link>, 'Our Story'),
    getItem(<Link to="/features">Features</Link>, 'Features'),
    getItem(<Link to="/myindici-for-providers">myindici for Providers</Link>,
     'MyIndici for Providers'), // Include path
    getItem(<Link to="/help-center">Help Centre</Link>, 'Help Centre'),
  ];
  const [open, setOpen] = useState(false);

  const showDrawer = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault(); // Event prevent default lagayein
    setOpen(true);
  };
  

  const onClose = () => {
    setOpen(false);
  };

  const handleLogIn=()=>
  {
    window.open("https://myindici.co.nz/")
  }
const[activeItem1, setActiveItem1]=useState(null);
const handleItemClick = (item:any) => {
  setActiveItem1(item);
};
  return (
    <Navbar expand="lg" className="bg-body-tertiary ">
      <Drawer title='myindici' className="myindici" onClose={onClose} open={open}>
        <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="my-4">
          <Nav.Link href="/" style={{ color: activeItem1 === 'home' ? "#00b8e5" : "", borderBottom: activeItem1 === 'home' ? "1px solid #00b8e5" : "" }} onClick={() => handleItemClick('home')}>Home</Nav.Link>
          <Nav.Link href="/our-story" style={{ color: activeItem1 === 'our-story' ? "#00b8e5" : "", borderBottom: activeItem1 === 'our-story' ? "1px solid #00b8e5" : "" }} onClick={() => handleItemClick('our-story')}>Our Story</Nav.Link>
          <Nav.Link href="/features" style={{ color: activeItem1 === 'features' ? "#00b8e5" : "", borderBottom: activeItem1 === 'features' ? "1px solid #00b8e5" : "" }} onClick={() => handleItemClick('features')}>Features</Nav.Link>
          <Nav.Link href="/myindici-for-providers" style={{ color: activeItem1 === 'providers' ? "#00b8e5" : "", borderBottom: activeItem1 === 'providers' ? "1px solid #00b8e5" : "" }} onClick={() => handleItemClick('providers')}>myindici for Providers</Nav.Link>
          <Nav.Link href="/help-center" style={{ color: activeItem1 === 'help-center' ? "#00b8e5" : "", borderBottom: activeItem1 === 'help-center' ? "1px solid #00b8e5" : "" }} onClick={() => handleItemClick('help-center')}>Help Center</Nav.Link>
        </Nav>
          <Button className="h-button"
            style={{ background: '#00B8E5', marginRight: '20px', borderColor: '#00B8E5', borderRadius: '8px' }}
            onClick={handleLogIn}
          > Log In </Button>
        </Navbar.Collapse>
      </Drawer>
      <Container>
        <Navbar.Brand href="/">
          <img src={MainVideo} alt="images" />
          <Button onClick={showDrawer} className="d-sm-block d-lg-none"> Menu</Button>    
        </Navbar.Brand>
        <Navbar.Collapse id="basic-navbar-nav">
          <Menu theme="dark" mode="horizontal"
           selectedKeys={['1']}
            items={itemsMenuAdmin} style={{ flex: 1, minWidth: 0 }} 
            className='headermenuitems'
          />
          <Button className="h-button"
            style={{ background: '#00B8E5', marginRight: '20px', borderColor: '#00B8E5', borderRadius: '8px' }}
            onClick={handleLogIn}
          > 
            Log In 
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
export default NavbarHeader;
